"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCovereageSelectorGroup = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledCovereageSelectorGroup = _styledComponents.default.div.withConfig({
  displayName: "CoverageSelectorGroupstyles__StyledCovereageSelectorGroup",
  componentId: "amguh-0"
})(["justify-content:center;display:flex;width:100%;&.c-coverage-selector-group-horizontal-layout{flex-direction:row;}&.c-coverage-selector-group-vertical-layout{flex-direction:column;}"]);

exports.StyledCovereageSelectorGroup = StyledCovereageSelectorGroup;